/*=========================================================================================
File Name: sidebarItems.js
Description: Sidebar Items list. Add / Remove menu items from here.
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default [
    // Dashboard
    {
        url: '/',
        name: 'Dashboard',
        icon: 'HomeIcon',
        acl: [
            'superadmin',
            'channel_admin',
            'bi_admin',
            'channel_user',
            'bi_user'
        ]
    },
    // User Management
    {
        url: '/user-management',
        name: 'User Management',
        icon: 'UserCheckIcon',
        acl: [
            'superadmin',
            'channel_admin'
        ]
    },
    // Partners
    {
        url: null,
        name: 'Partners',
        icon: 'UsersIcon',
        acl: [
            'superadmin',
            'channel_admin',
            'channel_user',
            'bi_admin',
            'bi_user',
        ],
        submenu: [
        // {
        //     url: '/partners/add-registrar/cnic',
        //     name: 'Add Registrar - CNIC',
        //     slug: 'add-registrar-cnic',
        //     i18n: 'add-registrar',
        //     acl: [
        //         'superadmin',
        //         'channel_admin',
        //         'bi_admin',
        //         'bi_user',
        //     ]
        // },
        {
            url: '/partners/add-registrar/tucows',
            name: 'Add Registrar - Tucows',
            slug: 'add-registrar-tucows',
            i18n: 'add-registrar',
            acl: [
                'superadmin',
                'channel_admin',
                'bi_admin',
                'bi_user',
            ]
        },
        {
            url: '/partners/add-reseller',
            name: 'Add Reseller',
            slug: 'add-reseller',
            i18n: 'add-reseller',
            acl: [
                'superadmin',
                'channel_admin',
                'bi_admin',
                'channel_user',
            ]
        },
        {
            url: '/partners/lists',
            name: 'View All Partners',
            slug: 'lists',
            i18n: 'lists',
            acl: [
                'superadmin',
                'channel_admin',
                'channel_user',
                'bi_admin',
                'bi_user'
            ],
        },
        {
            url: '/partners/requests',
            name: 'View Reseller Requests',
            slug: 'requests',
            i18n: 'requests',
            acl: [
                'superadmin',
                'channel_admin',
                'bi_admin'
            ]
        },
        {
            url: '/partners/overview',
            name: 'Partner Overview',
            slug: '/clients',
            i18n: 'clients',
            acl: [
                'channel_admin',
                'superadmin',
                'bi_admin',
            ]
        }
        ]
    },
    // Promos
    {
        url: null,
        name: "Promos",
        icon: "FilePlusIcon",
        submenu: [
        // {
        //     url: "/promos/add/cnic",
        //     name: "Add Promo - CNIC",
        //     slug: "add-cnic",
        //     i18n: "add-cnic",
        //     acl: [
        //         'superadmin',
        //         'channel_admin',
        //         'bi_admin',
        //         'channel_user'
        //     ]
        // },
        {
            url: "/promos/add/tucows",
            name: "Add Promo - Tucows",
            slug: "add-tucows",
            i18n: "add-tucows",
            acl: [
                'superadmin',
                'channel_admin',
                'bi_admin',
                'channel_user'
            ]
        },
        {
            url: "/promos/lists",
            name: "View All Promos",
            slug: "lists",
            i18n: "lists",
            acl: [
                'superadmin',
                'channel_admin',
                'bi_admin',
                'channel_user',
                'bi_user',
                'guest'
            ],
        },
        {
            url: "/promos/expiring",
            name: "View Expiring Promos",
            slug: "expiring",
            i18n: "expiring",
            acl: [
                'superadmin',
                'channel_admin',
                'bi_admin',
                'channel_user',
                'bi_user',
                'guest'
            ],
        },
        {
            url: "/promos/requests",
            name: "View Requests",
            slug: "requests",
            i18n: "requests",
            acl: [
                'superadmin',
                'channel_admin',
                'bi_admin',
                'channel_user',
                'bi_user'
            ],
        }
        ]
    },
    // Agreements
    {
        url: null,
        name: "Agreements",
        icon: "FileTextIcon",
        submenu: [
            {
                url: '/agreements/lists',
                name: 'View All Agreements',
                slug: 'lists',
                i18n: 'lists',
                acl: [
                    'superadmin',
                    'channel_admin',
                    'bi_admin',
                    'channel_user',
                    'bi_user',
                    'guest'
                ],
            },
            {
                url: '/agreements/requests',
                name: 'View Requests',
                slug: 'requests',
                i18n: 'requests',
                acl: [
                    'superadmin',
                    'channel_admin',
                    'channel_user',
                ],
            },
        ]
    },
    // Rebates
    {
        url: null,
        name: "Rebates",
        icon: "DollarSignIcon",
        submenu: [
            {
                url: "/rebates/scheduler",
                name: "Scheduler",
                slug: "scheduler",
                i18n: "scheduler",
                acl: [
                    'superadmin',
                    'channel_admin',
                    'bi_admin',
                    'channel_user',
                    'bi_user'
                ],
            },
            {
                url: "/rebates/calculator",
                name: "Calculator",
                slug: "calculator",
                i18n: "calculator",
                acl: [
                    'superadmin',
                    'channel_admin',
                    'bi_admin',
                    'channel_user',
                    'bi_user'
                ],
            },
            // TODO: Add it back when the module is ready
            // {
            //     url: "/rebates/payments",
            //     name: "Payments",
            //     slug: "payments",
            //     i18n: "payments",
            //     acl: [
            //         'superadmin',
            //         'channel_admin',
            //         'bi_admin',
            //         'channel_user',
            //         'bi_user',
            //     ],
            // },
            {
                url: "/rebates/cnic-compiler",
                name: "CNIC Compiler",
                slug: "cnic-compiler",
                i18n: "cnic-compiler",
                acl: [
                    'superadmin',
                    'channel_admin',
                    'bi_admin',
                    'channel_user',
                    'bi_user'
                ],
            },
        ]
    },
    // Manual Rebates
    {
        url: null,
        name: "Manual Rebates",
        icon: "ToolIcon",
        submenu: [{
            url: "/manual-rebates/delete",
            name: "Delete Rebate",
            slug: "delete-rebate",
            i18n: "delete-rebate",
            acl: [
                'superadmin',
                'channel_admin',
                'bi_admin',
                'channel_user',
                'bi_user'
            ]
        }]
    },
]